import { ButtonBase, Stack } from "@mui/material";
import { CbhIcon, Text } from "@src/appV2/redesign/system/ui-components";
import { type ReactElement } from "react";

interface WorkplaceSearchItemProps {
  workplaceId: string;
  name: string;
  searchTerm: string;
  isSelected: boolean;
  onSelect: (workplaceId: string) => void;
}

function highlightMatch(text: string, searchTerm: string): ReactElement {
  if (!searchTerm) {
    return <>{text}</>;
  }

  const lowerText = text.toLowerCase();
  const lowerSearch = searchTerm.toLowerCase();
  const index = lowerText.indexOf(lowerSearch);

  if (index === -1) {
    return <>{text}</>;
  }

  const before = text.slice(0, index);
  const match = text.slice(index, index + searchTerm.length);
  const after = text.slice(index + searchTerm.length);

  return (
    <>
      {before}
      <Text bold inline variant="body1">
        {match}
      </Text>
      {after}
    </>
  );
}

export function WorkplaceSearchItem(props: WorkplaceSearchItemProps) {
  const { workplaceId, name, searchTerm, isSelected, onSelect } = props;

  return (
    <ButtonBase
      aria-pressed={isSelected}
      sx={{
        width: "100%",
        textAlign: "left",
        paddingX: 5,
        paddingY: 6,
        borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
        ...(isSelected && {
          backgroundColor: (theme) => theme.palette.action.selected,
        }),
      }}
      onClick={() => {
        onSelect(workplaceId);
      }}
    >
      <Stack direction="row" spacing={4} alignItems="center" sx={{ width: "100%" }}>
        <CbhIcon type="building" size="small" sx={{ opacity: 0.5 }} />
        <Text variant="body1">{highlightMatch(name, searchTerm)}</Text>
      </Stack>
    </ButtonBase>
  );
}
